<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent transition="fade-transition" max-width="600px" :fullscreen="$vuetify.breakpoint.xsOnly")

    v-card(flat)
      v-card-title.px-5
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="closeDialog()" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.primary500--text {{ isEditing ? 'Pickup address' : 'Setup local delivery' }}

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      v-card-text.pa-0(v-else)
        v-form(ref="form")
          v-card.pa-4.mx-4.mb-12(outlined flat)
            .s1 {{ $t('enter_pickup_address') }}
            .c1.basic600--text {{ $t('enter_pickup_address_text') }}
            .address.mt-4
              address-inputs-id(v-if="isIndoAddress" :parentAddress.sync="address")
              address-inputs(v-else :parentAddress.sync="address" :autofillPostcode="true")

            .company-phone
              div.label.basic600--text.text-uppercase {{$t('phone.label')}}
              v-text-field.mt-2(v-model='address.phone' :placeholder="$t('phone.placeholder')" dense outlined height="40" type="tel" background-color="basic200" :rules="rules.not_empty")
            
            .latlng
              div.p2.default--text.mb-2 Drag pinpoint icon 📍to adjust pickup location
              gmap-map(:zoom="16" :center="{lat:address.lat, lng:address.lng}" :options="{streetViewControl:false}" style="width:100%; height:400px;")
                gmap-marker(:draggable="true" :position="{lat:address.lat, lng: address.lng}" @dragend="updateCoordinate")
            

        v-layout.ma-4(v-if="!isEditing")
          v-spacer
          v-btn(color='textColorAccent' depressed :loading="isLoading" @click="clickSave")
            .button-AA-medium.basic100--text {{ $t('save_and_continue') }}

</template>

<script>
import Vue from "vue"
import { mapActions } from 'vuex'
import * as VueGoogleMaps from "vue2-google-maps"
import AddressInputs from '@/components/AddressInputs.vue'
import AddressInputsId from '@/components/AddressInputsId.vue'

Vue.use(VueGoogleMaps,{
  load:{ key: process.env.VUE_APP_GOOGLEMAP_API_KEY }
})

export default {
  name: 'LocalDeliveryAddress',
  props: ['open', 'company', 'isEditing', 'localdelivery'],
  components: { AddressInputs, AddressInputsId },
  data: () => ({
    isFetching: false,
    same_for_awb_address: false,
    address: {
      address_1: '',
      address_2: '',
      postcode: '',
      city: '',
      state: '',
      country: '',
      lat: null,
      lng: null,
      phone: ''
    },
    isFetchingAddress: false,
    isLoading: false,
    rules: {
      not_empty: [val => (val || '').length > 0 || 'This field is required']
    }
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    isIndoAddress () {
      if (this.$currency.code === 'IDR') {
        return true
      }
      return false
    }
  },
  mounted () {
    this.address = this.localdelivery.pickup_address
    if (!this.address.lat) { this.address.lat = 3.152815 }
    if (!this.address.lng) { this.address.lng = 101.703651 }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    closeDialog () {
      if (!this.isEditing) {
        this.showModal = !this.showModal
        return
      }
      if (!this.$refs.form.validate()) {
        return
      }
      this.localdelivery.pickup_address = this.address
      this.showModal = !this.showModal
      this.$emit('check-address')
    },
    clickSave() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      var params = {
        pickup_address: this.address
      }
      this.axios.patch(`/shipping/yezzashipping/settings/${this.company.slug}/local_delivery/${this.localdelivery.id}`, params)
        .then(() => {
          this.showModal = false
          this.$emit('finished')
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    updateCoordinate(location){
      this.address.lat = location.latLng.lat()
      this.address.lng = location.latLng.lng()
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "update_company": "Update company details",
    "company_logo": "Company logo",
    "company_name": {
      "label": "Company Name",
      "placeholder": "Write your company name here"
    },
    "phone": {
      "label": "Phone number",
      "placeholder": "Enter phone number"
    },
    "registration_number": {
      "label": "Company Registration No",
      "placeholder": "Write your company registration number here"
    },
    "address_1": {
      "label": "Address Line 1",
      "placeholder": "e.g. K-3-01, Conezion, Persiaran IRC3"
    },
    "address_2": {
      "label": "Address Line 2",
      "placeholder": "e.g. IOI Resort City"
    },
    "postcode": {
      "label": "Postcode",
      "placeholder": "e.g. 62502"
    },
    "city": {
      "label": "City",
      "placeholder": "e.g. Putrajaya"
    },
    "state": {
      "label": "State",
      "placeholder": "e.g. Wilayah Persekutuan Putrajaya"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Malaysia"
    },
    "tax_rate": {
      "label": "Tax rate",
      "placeholder": "Default tax rate for price calculation"
    },
    "enter_pickup_address": "Enter your pickup address",
    "enter_pickup_address_text": "This is where couriers would go to collect your packages for delivery."
  },
   "id": {
     "update_company": "Update Detail Perusahaan",
    "company_logo": "Logo perusahaan",
    "company_name": {
      "label": "Nama Perusahaan",
      "placeholder": ""
    },
    "company_phone": {
      "label": "Nomor Telepon",
      "placeholder": ""
    },
    "registration_number": {
      "label": "No Registrasi Perusahaan",
      "placeholder": ""
    },
   "address_1": {
      "label": "Nama Jalan, Gedung, No Rumah, RT/RW, Kelurahan",
      "placeholder": "e.g. Jalan Prof. Joko Sutono Sh No.999, RT.14/RW.6, Petogogan, "
    },
    "address_2": {
      "label": "Kecamatan",
      "placeholder": "Kec. Kby. Baru"
    },
    "postcode": {
      "label": "Kode Pos",
      "placeholder": "12160"
    },
    "city": {
      "label": "Kota",
      "placeholder": "Kota Jakarta Selatan"
    },
    "state": {
      "label": "Provinsi",
      "placeholder": "DKI Jakarta"
    },
    "country": {
      "label": "Country",
      "placeholder": "e.g. Indonesia"
    },
    "tax_rate": {
      "label": "Persentase Pajak",
      "placeholder": "Default tax rate for price calculation"
    },
    "enter_pickup_address": "Tulis alamat penjemputan",
    "enter_pickup_address_text": "Ini adalah alamat kurir menjemput paket kamu"
  }
}
</i18n>
